<template>
  <pt-edit-password class="pt-edit-password__withData"></pt-edit-password>
</template>

<script>
import PtEditPassword from './index'
export default {
  name: 'pt-edit-password__withData',
  components: {
    'pt-edit-password': PtEditPassword
  }
}
</script>
